export const PERSONAL_DATA_SUB_CATEGORIES = [
    { value: "Personal Identifiers", label: "Personal Identifiers" },
    { value: "Contact Information", label: "Contact Information" },
    { value: "Employment Data", label: "Employment Data" },
    { value: "Customer Data", label: "Customer Data" },
    { value: "Supplier Data", label: "Supplier Data" },
    { value: "Location Data", label: "Location Data" },
    { value: "Device Data", label: "Device Data" },
];

export const SPECIAL_CATEGORY_PERSONAL_DATA_SUB_CATEGORIES = [
    { value: "Health Data", label: "Health Data" },
    { value: "Biometric Data", label: "Biometric Data" },
    { value: "Genetic Data", label: "Genetic Data" },
    { value: "Political Opinions", label: "Political Opinions" },
    { value: "Religious Beliefs", label: "Religious Beliefs" },
    { value: "Trade Union Membership", label: "Trade Union Membership" },
    { value: "Sexual Orientation", label: "Sexual Orientation" },
    { value: "Racial or Ethnic Origin", label: "Racial or Ethnic Origin" },
];

export const getSubcategoryOptions = (dataType) => {
    if (dataType === "Personal Data") {
        return PERSONAL_DATA_SUB_CATEGORIES;
    }

    if (dataType === "Special Category Personal Data") {
        return SPECIAL_CATEGORY_PERSONAL_DATA_SUB_CATEGORIES;
    }

    return [];
};

export const requiresSubcategory = (dataType) =>
    dataType === "Personal Data" || dataType === "Special Category Personal Data";

export const requiresTextSubcaregory = (dataType) => dataType === "Other";
